<div class="content no-padding" id="trip">
	<div *ngIf="globalProvider == 'Google'">
		<app-gmap></app-gmap>
	</div>
	<div *ngIf="globalProvider == 'OpenStreetMap'">
		<app-openmap></app-openmap>
	</div>
</div>
<div class="modal fade" tabindex="-1" role="dialog" id="fieldOpt">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header pb-0">
                <h4 class="modal-title">Display fields:</h4>
            </div>
            <div class="modal-body pt-1">
				<div class="row mb-4">
					<div class="col-md-12">
						<input type="checkbox" [(ngModel)]="allDisplays" id="allDisplays" (change)="evSelectAll($event)"><label for="allDisplays">&nbsp;Select All</label>
					</div>
				</div>
                <div class="row mb-4">
					<div class="row">
						<div class="col-md-12">
							<div class="col-md-6" *ngFor="let fld of fieldDisplays; let i = index">
								<input type="checkbox" [(ngModel)]="fld.value" id="fld_id_{{i}}" (change)="selectFld()"><label for="fld_id_{{i}}">&nbsp;{{fld.name}}</label>
							</div>
						</div>
					</div>
                </div>
				<div class="row" style="display: flex;justify-content: flex-end;">
					<button type="button"  class="btn  btn-default" (click)="saveFields(0)" style="margin-right: 5px;">Cancel</button>
                    <button type="button"  class="btn  btn-primary" (click)="saveFields(1)">Save</button>
				</div>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" tabindex="-1" role="dialog" id="expirySet">
    <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
			<div class="modal-header bg-light p-3 text-right">
				<button (click)="closeModalBtn()" type="button" class="btn btn-close" id="close-modal"> X </button>
			</div>
            <div class="modal-body pt-1">
				<div class="row mb-4">
					<p>
				</div>
                <div class="row mb-4">
					<div class="row">
						<div class="col-md-12">
							<div class="form-group">
								<label for="date_st">Effective Time (Hour)</label>
								<input type="number" class="form-control" [(ngModel)]="eff_time" (change)="confirmShare()">
								<input type="hidden" id="share-unit-id" [(ngModel)]="share_vehicle_id">
							</div>
						</div>
					</div>
					<div class="row show-url-share">
						<div class="col-md-12">
							<p style="margin-top: 10px;font-size:16px;">Share link:</p>
							<div class="input-group" style="width:100%"><input type="text" [(ngModel)]="baseShareUrl" readonly class="form-control" style="width:80%" id="mapUrl"><button class="btn btn-primary" style="padding-top:8px;padding-bottom:8px;" type="button" id="copyBtn">Copy</button></div>
							<p class="mdb-5 force-hide noti-copied" style="margin-top: 8px;font-size:12px;">Link copied!</p>
						</div>
					</div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-backdrop fade" id="fieldOptBackdrop"></div>